import { SimpleCommentsScreen, SimpleCommentsStructure } from "structure/simple-comments";
import { component, demoFile, variant, componentWithVariants } from "system/demo";

demoFile('structure/simple-comments');

const collections = {
    comment: [
        {key: 1, from: 'a', text: 'I love this movie!'},
        {key: 2, from: 'b', text: 'My comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.'},
        {key: 3, from: 'c', replyTo: 1, text: 'I think this movie is okay.'},
        {key: 4, from: 'a', replyTo: 2, text: 'This reply should be shown'},
        {key: 5, from: 'e', text: 'Comment with no replies'}
    ]
}

componentWithVariants('SimpleCommentsScreen', SimpleCommentsScreen, {}, [
    variant(null, {
        config: SimpleCommentsStructure.defaultConfig,
        state: {collections}
    })
])